import type { ReactNode } from 'react';
import type { MeResponse } from '@hearth/shared';
import { SiteFooter } from '../legal/SiteFooter';
import { Wordmark } from '../Wordmark';
import { linkTo, usePath } from '../router';
import type { Api } from '../api';
import { AccountMenu } from './AccountMenu';
import './app.css';

/**
 * The app pages' frame: the wordmark, who's signed in (their account menu), the page and the footer. Tidy,
 * unlike the landing. `home`: where the wordmark goes (the policies, open to anyone, send it to `/`).
 */
export function Shell({ me, api, onSignOut, home = '/app', children }: { me?: MeResponse; api?: Api; onSignOut?: () => void; home?: string; children: ReactNode }) {
  const path = usePath();
  return (
    <div className="shell">
      <header className="topbar">
        <div className="wrap topbar-inner">
          <a href={home} className="home-link" aria-label={home === '/app' ? 'Hearth: your servers' : 'Hearth'}><Wordmark /></a>
          {me && onSignOut && (
            <div className="who">
              {me.admin && (
                <a className="admin-link" aria-current={path === '/app/admin' ? 'page' : undefined} {...linkTo('/app/admin')}>Admin</a>
              )}
              <AccountMenu me={me} name={displayName(me)} api={api} onSignOut={onSignOut} />
            </div>
          )}
        </div>
      </header>
      <main className="wrap page">{children}</main>
      <SiteFooter />
    </div>
  );
}

/** The name to show: Discord's display name or username, Google's name, else the email's name. */
export function displayName(me: MeResponse): string {
  return me.displayName ?? me.name ?? me.username ?? me.email?.split('@')[0] ?? 'You';
}
